// Docs nav renders a top-level article plus one level of subpages. A row nested
// deeper than that stays public at its own URL while no tree view shows it, so
// every nav surface lifts the deeper rows next to their parent instead.
export function flattenSubpageTree<S extends object>(
	subpages: readonly S[] | undefined | null,
): S[] {
	const flat: S[] = []
	for (const subpage of subpages ?? []) {
		const nested = (subpage as { subpages?: readonly S[] | null }).subpages
		flat.push({ ...subpage, subpages: [] })
		flat.push(...flattenSubpageTree(nested))
	}
	return flat
}
